// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';

import { getAnalyticsMetadataAttribute } from '@amzn/awsui-component-toolkit/internal/analytics-metadata';

import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { GeneratedAnalyticsMetadataTilesComponent } from './analytics-metadata/interfaces';
import { TilesProps } from './interfaces';
import InternalTiles from './internal';

import analyticsSelectors from './analytics-metadata/styles.css.js';

export { TilesProps };

const Tiles = React.forwardRef((props: TilesProps, ref: React.Ref<TilesProps.Ref>) => {
  const baseComponentProps = useBaseComponent('Tiles', {
    props: { columns: props.columns, readOnly: props.readOnly },
  });
  const componentAnalyticsMetadata: GeneratedAnalyticsMetadataTilesComponent = {
    name: 'awsui.Tiles',
    label: { root: 'self' },
    properties: {
      value: `${props.value}`,
      valueLabel: `.${analyticsSelectors.selected}`,
    },
  };
  return (
    <InternalTiles
      ref={ref}
      {...props}
      {...baseComponentProps}
      {...getAnalyticsMetadataAttribute({
        component: componentAnalyticsMetadata,
      })}
    />
  );
});

applyDisplayName(Tiles, 'Tiles');
export default Tiles;



// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/src/tiles/index.tsx